import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=06c220f6&scoped=true&lang=css"
import "./HelloWorld.vue?vue&type=style&index=1&id=06c220f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c220f6"]])

export default __exports__